import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M10.2857 8.39723V6.71387C10.2857 5.99371 10.6457 5.30054 11.2543 4.98547C12.3 4.44536 13.32 5.14751 13.62 6.05671C13.7314 6.38978 14.0571 6.59684 14.4 6.59684C14.9829 6.59684 15.42 5.9847 15.2057 5.41758C14.6057 3.77922 12.8486 2.50993 10.9457 3.18508C9.48857 3.69819 8.57143 5.23754 8.57143 6.8579V8.39723C7.14857 8.39723 6 9.6035 6 11.0978V18.2994C6 19.7937 7.14857 21 8.57143 21H15.4286C16.8514 21 18 19.7937 18 18.2994V11.0978C18 9.6035 16.8514 8.39723 15.4286 8.39723H10.2857ZM16.2857 18.2994C16.2857 18.7945 15.9 19.1996 15.4286 19.1996H8.57143C8.1 19.1996 7.71429 18.7945 7.71429 18.2994V11.0978C7.71429 10.6027 8.1 10.1976 8.57143 10.1976H15.4286C15.9 10.1976 16.2857 10.6027 16.2857 11.0978V18.2994Z' />
        </SvgIcon>
    );
});
